import { z } from 'zod';

export type RequiredField = {
  name: string;
  label: string;
  default?: any;
  type?: string;
  min?: any;
  max?: any;
};

const isFilled = (value: any, rf: RequiredField): boolean => {
  let val = value;
  if ((val === null || val === undefined || val === '') && rf.default) {
    val = rf.default;
  }
  if (val === null || val === undefined || val === '') {
    return false;
  }
  if (Array.isArray(val) && !val.every((item) => item !== null && item !== '')) {
    return false;
  }
  return true;
};

const buildFieldValidator = (rf: RequiredField) => {
  let validator: z.ZodTypeAny = z.any().refine((value) => isFilled(value, rf), {
    message: `Please fill in the ${rf.label} field before proceeding`,
  });

  if (rf.type === 'number' && typeof rf.min === 'number' && typeof rf.max === 'number') {
    validator = validator.refine(
      (value) => {
        if (value === null || value === undefined || value === '') return true;
        const n = Number(value);
        return !isNaN(n) && n >= rf.min && n <= rf.max;
      },
      { message: `${rf.label} must be between ${rf.min} and ${rf.max}` },
    );
  }

  return validator;
};

export const validateRequiredFields = (
  requiredFields: RequiredField[],
  formData: any,
  getFormDataItem: (data: any, name: string) => any,
): { ok: boolean; message?: string } => {
  const shape: Record<string, z.ZodTypeAny> = {};
  const flatValues: Record<string, any> = {};

  requiredFields.forEach((rf) => {
    flatValues[rf.name] = getFormDataItem(formData, rf.name);
    shape[rf.name] = buildFieldValidator(rf);
  });

  const result = z.object(shape).safeParse(flatValues);
  if (result.success) {
    return { ok: true };
  }
  return { ok: false, message: result.error.issues[0]?.message };
};
